import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { getSeoCountriesJSON } from '@pepper/utils/src/api/utils/utils'

const STALE_TIME_MS = 15 * 60 * 1000 // 15 mins

async function handleApiRequest() {
  const response = await getSeoCountriesJSON()
  if (response.status !== 'ok') {
    throw new Error(response.error)
  }
  return response.data?.response
}

export function useSEOCountriesJSON(): UseQueryResult<
  Record<SEOCountries, SEOCountryData>,
  Error
> {
  return useQuery({
    queryKey: ['seo-countries'],
    queryFn: () => handleApiRequest(),
    staleTime: STALE_TIME_MS
  })
}
